export default __webpack_public_path__ + "static/media/face_1_31.a24b0d25.png";